import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import DeleteSweepRoundedIcon from "@mui/icons-material/DeleteSweepRounded";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import RuleFolderIcon from "@mui/icons-material/RuleFolder";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import ArticleIcon from "@mui/icons-material/Article";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import FolderSpecialIcon from "@mui/icons-material/FolderSpecial";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import StorageIcon from "@mui/icons-material/Storage";
import TuneIcon from "@mui/icons-material/Tune";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import HistoryIcon from "@mui/icons-material/History";
import CachedIcon from "@mui/icons-material/Cached";
import { LD_FLAGS } from "../launchdarkly/flags";

const items = [
  {
    tag: "Admin",
    href: "/admin/clients",
    icon: <SupervisorAccountIcon />,
    title: "Clients",
    flag: LD_FLAGS.SHOW_CLIENT_CONFIG,
    description:
      "View and manage client configurations, including their settings and associated metadata.",
  },
  {
    tag: "Monitoring",
    href: "/tasks",
    icon: <AssignmentRoundedIcon />,
    title: "Tasks",
    description:
      "Retrieve and monitor system or process tasks for diagnostic and operational insights.",
  },
  {
    tag: "Developer",
    href: "/monitoring/unused-sql-objects",
    icon: <StorageIcon />,
    title: "Unused SQL Objects",
    description:
      "Monitor and review database objects that haven&apos;t been used recently, including tables, views, and stored procedures.",
  },
  {
    tag: "Developer",
    href: "/admin/audit",
    icon: <HistoryIcon />,
    title: "Audit Logs",
    description:
      "Browse audit trail records — such as one-off script executions — across logical databases, with filtering, sorting, and date-range search.",
  },
  {
    tag: "Developer",
    href: "/admin/cache",
    icon: <CachedIcon />,
    title: "Cache Management",
    description:
      "Warm the cache, browse cached keys grouped by tag, and purge individual keys, whole tags, or the entire cache.",
  },
  {
    tag: "Files Management",
    href: "/admin/file-monitor",
    icon: <FolderOpenIcon />,
    title: "File Monitor",
    description:
      "Monitor and manage uploaded files for all clients, including file history, download, reprocess, and delete operations.",
  },
  {
    tag: "Files Management",
    href: "/admin/file-upload",
    icon: <DriveFolderUploadIcon />,
    title: "File Upload",
    flag: LD_FLAGS.SHOW_CLIENT_UPLOAD,
    description: "Upload files for clients in bulk using file uploads.",
  },
  {
    tag: "Files Management",
    href: "/admin/file-explorer",
    icon: <FolderSpecialIcon />,
    title: "File Explorer",
    description:
      "Browse, download, delete, and rehydrate files stored in blob storage, organized by folder.",
  },
  {
    tag: "Files Management",
    href: "/admin/ingestion",
    icon: <MoveToInboxIcon />,
    title: "Client Ingestion",
    description:
      "Configure where each client's files are collected from: SFTP folders and email mailbox rules.",
  },
  {
    tag: "Scoring",
    href: "/admin/scoring/rules",
    icon: <RuleFolderIcon />,
    title: "Scoring Rules",
    flag: LD_FLAGS.SHOW_SCORING_RULES,
    description:
      "Configure global scoring rules by adjusting scores and enabling or disabling rules across all clients.",
  },
  {
    tag: "Scoring",
    href: "/admin/scoring/client-rules",
    icon: <ManageAccountsIcon />,
    title: "Scoring Rules (Client)",
    flag: LD_FLAGS.SHOW_SCORING_RULES,
    description:
      "Enable or disable specific scoring rules for individual clients to customize their scoring behavior.",
  },
  {
    tag: "Admin",
    href: "/admin/junk-values",
    icon: <DeleteSweepRoundedIcon />,
    title: "Junk Values",
    flag: LD_FLAGS.SHOW_JUNK_VALUES,
    description:
      "Handle junk or irrelevant values in your system by adding, deleting, or reviewing them.",
  },

  {
    tag: "Admin",
    href: "/admin/ignore-list",
    icon: <PlaylistRemoveIcon />,
    title: "Ignore List",
    flag: LD_FLAGS.SHOW_IGNORE_LIST,
    description:
      "Manage entities to be excluded from processing, such as emails, phones, or vehicles.",
  },
  {
    tag: "Admin",
    href: "/admin/cleaning",
    icon: <CleaningServicesIcon />,
    title: "Data Cleaning",
    description:
      "Clean and standardize data by removing duplicates, correcting errors, and ensuring data quality.",
  },
  {
    tag: "Templates",
    href: "/admin/templates",
    icon: <ArticleIcon />,
    title: "Templates",
    flag: LD_FLAGS.SHOW_TEMPLATES,
    description:
      "Manage and configure data templates for defining field structures and validation rules.",
  },
  {
    tag: "MDA",
    href: "/admin/filters",
    icon: <TuneIcon />,
    title: "Filter Options",
    flag: LD_FLAGS.SHOW_FILTER_OPTIONS,
    description:
      "Manage MDA search filter types and their options, and control which filters are visible to which clients.",
  },
  {
    tag: "MDA",
    href: "/admin/mda/spreadsheet-mappings",
    icon: <ViewColumnIcon />,
    title: "Spreadsheet Column Mappings",
    flag: LD_FLAGS.SHOW_MDA_SPREADSHEET_MAPPINGS,
    description:
      "Configure which source columns map to which destination columns, in what order, for the MDA extract spreadsheet export, per client or as the default template.",
  },
];

const categories = [
  "All categories",
  "Admin",
  "Developer",
  "Files Management",
  "Monitoring",
  "Scoring",
  "MDA",
  "Templates",
];

export { categories, items };
